export default class UserOffers {
  constructor($scope, OfferService, PaginationService) {
    $scope.quick_search = function() {
      window.filter_table('table#offers', $scope.query);
    };

    $scope.get_offers = function() {
      $scope.searching = true;
      OfferService.get_manage_data($scope.filter).then(function(data) {
        $scope.offers = data.offers;
        $scope.pagination = PaginationService.get_pagination(data.pagination);
        $scope.searching = false;
      });
    };

    $scope.get_page_data = function(page) {
      $scope.filter.page = page;
      $scope.get_offers();
    };

    $scope.init_filters = function() {
      $scope.filter = {
        page: 1,
        per_page: 50,
        sort_by: null,
        sort_by_mode: 1
      };
      if (window.is_buyer)
        $scope.filter.buyer_id = window.user_id;
      else
        $scope.filter.supplier_id = window.user_id;
    };

    $scope.getDescriptionPercentage = function(offer) {
      var percentage = 0;
      if (offer.subtitleEN)
        percentage += 33;
      if (offer.full_description)
        percentage += 33;
      if (offer.notes)
        percentage += 34;
      return percentage;
    };

    $scope.init = function() {
      $scope.init_filters();
      $scope.get_offers();
    };

    $scope.init();
  }
}

UserOffers.$inject = ['$scope', 'OfferService', 'PaginationService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-offers.ctrl.js